export class OblInteracaoService {
    $q;
    OblInteracao;
    FuncionarioEntidadeProprietaria;
    constructor($q, OblInteracao, FuncionarioEntidadeProprietaria) {
        this.$q = $q;
        this.OblInteracao = OblInteracao;
        this.FuncionarioEntidadeProprietaria = FuncionarioEntidadeProprietaria;
    }
    tableVisitas(query) {
        return this.OblInteracao.tableVisitas(query).$promise;
    }
    tableOrcamentos(query) {
        return this.OblInteracao.tableOrcamentos(query).$promise;
    }
    options() {
        return this.OblInteracao.options().$promise;
    }
    export(query) {
        return this.OblInteracao.export(query).$promise;
    }
    findTecnicos() {
        const defer = this.$q.defer();
        this.FuncionarioEntidadeProprietaria.find({
            filter: {
                where: {
                    entidadeProprietariaId: 3,
                    active: true
                },
                include: {
                    relation: 'funcionario'
                }
            }
        })
            .$promise.then(f => {
            const users = [];
            f.forEach(r => {
                if (r.funcionario) {
                    users.push(r.funcionario);
                }
            });
            defer.resolve(users.sort((a, b) => a.name.localeCompare(b.name)));
        })
            .catch(e => {
            defer.reject(e);
        });
        return defer.promise;
    }
}
OblInteracaoService.$inject = ['$q', 'OblInteracao', 'FuncionarioEntidadeProprietaria'];
